import {
  Button,
  FormControl,
  FormLabel,
  HStack,
  Input,
  Stack,
  useBoolean,
  useDisclosure,
} from '@elkaso-app/web-design';
import { BaseFilterButton } from 'components/base-table/filters/base-filter-button';
import { usePageParams } from 'hooks/use-page-params';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';

type TInputs = {
  minQuota: string;
  maxQuota: string;
};

const defaultValues: TInputs = {
  minQuota: '',
  maxQuota: '',
};

export const QuotaRangeFilterButton = () => {
  const [isActive, setIsActive] = useBoolean(false);
  const { isOpen, onClose, onOpen } = useDisclosure();
  const { getPageParams, setPageParams } = usePageParams();
  const params = getPageParams();

  // Update active filter button
  useEffect(() => {
    if (params.minQuota || params.maxQuota) setIsActive.on();
    else setIsActive.off();
  }, [params.minQuota, params.maxQuota, setIsActive]);

  const { handleSubmit, formState, reset, setValue, register } = useForm<TInputs>({
    defaultValues: { ...defaultValues },
  });

  // Update values when params change
  useEffect(() => {
    setValue('minQuota', params.minQuota ? String(params.minQuota) : '');
    setValue('maxQuota', params.maxQuota ? String(params.maxQuota) : '');
  }, [params.minQuota, params.maxQuota, setValue]);

  const onSubmit = (data: TInputs) => {
    if (data.minQuota && data.minQuota.trim()) {
      params.minQuota = data.minQuota.trim();
    } else {
      delete params.minQuota;
    }

    if (data.maxQuota && data.maxQuota.trim()) {
      params.maxQuota = data.maxQuota.trim();
    } else {
      delete params.maxQuota;
    }

    setPageParams(params);
    onClose();
    reset(data);
  };

  const handleClose = () => {
    onClose();
    setValue('minQuota', params.minQuota ? String(params.minQuota) : '');
    setValue('maxQuota', params.maxQuota ? String(params.maxQuota) : '');
  };

  const handleDisableFilterButton = () => {
    return Object.keys(formState.dirtyFields).length === 0;
  };

  return (
    <BaseFilterButton
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={handleClose}
      isActive={isActive}
      formComponent={
        <Stack as='form' spacing='lg' p='md' pt='lg' onSubmit={handleSubmit(onSubmit)}>
          <FormControl>
            <FormLabel>Minimum Quota</FormLabel>
            <Input {...register('minQuota')} placeholder='Enter minimum quota' type='number' />
          </FormControl>

          <FormControl>
            <FormLabel>Maximum Quota</FormLabel>
            <Input {...register('maxQuota')} placeholder='Enter maximum quota' type='number' />
          </FormControl>

          <HStack justify='flex-end'>
            <Button variant='outline' colorScheme='red' onClick={handleClose}>
              Cancel
            </Button>
            <Button variant='solid' colorScheme='red' type='submit' disabled={handleDisableFilterButton()}>
              Filter
            </Button>
          </HStack>
        </Stack>
      }
    />
  );
};
